const initialState = {
  uploadError: {},
  loading: false,
  walkthroughData: {},
};

const walkthroughs = (state = initialState, { type, payload }) => {
  switch (type) {
    case 'WALKTHROUGH_CREATE_REQUEST':
      return {
        ...state,
        loading: true,
      };
    case 'WALKTHROUGH_CREATE_SUCCESS':
      return {
        ...state,
        loading: false,
        walkthroughData: payload.walkthroughData,
        uploadError: '',
      };
    case 'WALKTHROUGH_CREATE_FAILURE':
      return {
        ...state,
        walkthroughData: {},
        loading: false,
        uploadError: payload.errors,
      };
    default:
      return state;
  }
};

export default walkthroughs;



// WEBPACK FOOTER //
// ./client/app/reducers/walkthroughs.js